import * as queryString from './queryStringHelper';

// Helper function to create login URL with callback
export const createLoginUrlWithCallback = (
  currentPath: string = window.location.pathname + window.location.search,
) => {
  const encodedCallback = currentPath;

  // Parse current URL parameters and construct login redirect with callback
  const currentParams = queryString.parse(window.location.search.substring(1));
  const loginParams = { ...currentParams };

  // check s'il n'y a pas encore de callback
  if (!loginParams.callback && !currentParams.isSwitch) {
    loginParams.callback = encodedCallback;
  }
  let loginQuery =
    Object.keys(loginParams).length > 0 ? `${queryString.stringify(loginParams)}` : ``;

  // replace logout by '' if exists
  if (loginQuery.includes('logout')) {
    loginQuery = loginQuery.replace('%2Fauth%2Flogout', '');
  }

  return loginQuery;
};
